// extracted by mini-css-extract-plugin
module.exports = {"title":"App_title__2oBiX"};